import { render, staticRenderFns } from "./FormControlProductTypesFeatures.vue?vue&type=template&id=3f04fc7b&scoped=true"
import script from "./FormControlProductTypesFeatures.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlProductTypesFeatures.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlProductTypesFeatures.vue?vue&type=style&index=0&id=3f04fc7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f04fc7b",
  null
  
)

export default component.exports